import BigNumber from 'bignumber.js';
import { atom } from 'jotai';

import { FTAsset, NFTAsset } from '../types';

export type SafeFtBalance = {
  asset: FTAsset;
  balance: string;
};

export type SafeNftBalance = {
  asset: NFTAsset;
  balance: string;
  ids: number[];
};

export type SafeStxBalance = {
  available: BigNumber;
  locked: BigNumber;
};

const initialState = {
  available: new BigNumber(0),
  locked: new BigNumber(0),
};

export const safeStxBalanceAtom = atom<SafeStxBalance>(initialState);
export const ftBalancesAtom = atom<SafeFtBalance[]>([]);
export const nftBalancesAtom = atom<SafeNftBalance[]>([]);
export const safeTotalBalanceAtom = atom(0);
